import { render, staticRenderFns } from "./_MarketReportResult_BusinessRegistrationPoiChart.vue?vue&type=template&id=130ca822&"
import script from "./_MarketReportResult_BusinessRegistrationPoiChart.vue?vue&type=script&lang=js&"
export * from "./_MarketReportResult_BusinessRegistrationPoiChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports